
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.353 33.483"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M3.621 24.245c-1.269 2.2-1.108 6.914 1.816 8.6s7.511-.286 8.781-2.485c3.137-5.434 1.272-13.687 1.272-13.687s-8.751 2.172-11.869 7.572z","fill":"#002de6"}}),_c('path',{attrs:{"d":"M1.208 22.915A16.611 16.611 0 010 16.677 16.685 16.685 0 0116.677 0a16.685 16.685 0 0116.676 16.677 16.684 16.684 0 01-16.676 16.676q-.48 0-.953-.027a5.231 5.231 0 00.3-.463 20.9 20.9 0 002.453-8.031 8.357 8.357 0 006.553-8.155 8.353 8.353 0 00-8.353-8.349 8.353 8.353 0 00-8.35 8.349v.128a22 22 0 00-7.119 6.11z"}})])])
          )
        }
      }
    